<template>
    <div class="modal-passport-example">
        <div class="modal-passport-example__title">
            Подсказка
        </div>
        <div class="modal-passport-example__description">
            <div>
                Загрузите четкое фото полного разворота паспорта без обрезки и бликов, где все данные и печати хорошо читаются, ориентируясь на пример.
            </div>
            <div class="modal-passport-example__description-items">
                <div class="modal-passport-example__description-list">
                    <div class="modal-passport-example__description-item">
                        <div class="modal-passport-example__description-item-icon">
                            <icon name="success" width="12" />
                        </div>
                        <div>
                            Полный разворот, не обрезан
                        </div>
                    </div>
                    <div class="modal-passport-example__description-item">
                        <div class="modal-passport-example__description-item-icon">
                            <icon name="success" width="12" />
                        </div>
                        <div>
                            Нет бликов и теней
                        </div>
                    </div>
                </div>
                <div class="modal-passport-example__description-list">
                    <div class="modal-passport-example__description-item">
                        <div class="modal-passport-example__description-item-icon">
                            <icon name="success" width="12" />
                        </div>
                        <div>
                            Все данные хорошо читаются
                        </div>
                    </div>
                    <div class="modal-passport-example__description-item">
                        <div class="modal-passport-example__description-item-icon">
                            <icon name="success" width="12" />
                        </div>
                        <div>
                            Документ без повреждений
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-passport-example__photos">
            <div class="modal-passport-example__photos-item">
                <div class="modal-passport-example__photos-item-title">
                    Разворот с персональными данными
                </div>
                <div class="modal-passport-example__photos-item-image">
                    <img v-bind:src="require('/static/images/passport-1.png')" height="240"/>
                </div>
            </div>
            <div class="modal-passport-example__photos-item">
                <div class="modal-passport-example__photos-item-title">
                    Разворот с действующей регистрацией
                </div>
                <div class="modal-passport-example__photos-item-image">
                    <img v-bind:src="require('/static/images/passport-2.png')" height="190"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'modal-passport-example',
    computed: {
    },
    methods: {
        close() {
            this.$store.commit('modals/pop');
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.modal-passport-example {
    .modal();

    flex: 1;
    width: 100%;
    max-width: 820px;
    padding: 48px 16px;

    &__title {
        .typography-medium();

        margin-bottom: 24px;
    }
    &__description {
        .typography-heading();
        display: flex;
        flex-direction: column;
        gap: 24px;
        margin-bottom: 24px;

        &-list {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 24px;
        }
        &-item {
            display: flex;
            align-items: center;
            gap: 12px;
            &-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                color: white;
                background-color: @color-primary;
                border-radius: 50%;
            }
        }
    }
    &__photos {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
        &-item {
            display: flex;
            flex-direction: column;
            gap: 12px;
            padding: 12px;
            height: 292px;
            border: 1px solid @color-gray-light-secondary;
            border-radius: @border-radius-lg;
            background-color: @color-gray-lighter;
            &-title {
                .typography-caption();

                text-transform: uppercase;
                font-weight: bold;
                text-align: center;
            }
            &-image {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }

    @media @media-md-down {
        padding: 0;

        &__description {
            &-list {
                grid-template-columns: 1fr;
                gap: 0;
            }
        }
        &__photos {
            grid-template-columns: 1fr;
            gap: 16px;
        }
    }
}
</style>
